import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** Visible text under/next to the ring; also what screen readers announce. */
  label?: string;
  /**
   * block      ring + label, centred (default)
   * inline     ring + label on one line, no padding
   * fullscreen block filling the viewport (route-level loading)
   * bare       ring only; pass `label` to announce it, omit when text sits beside it
   */
  layout?: 'block' | 'inline' | 'fullscreen' | 'bare';
  className?: string;
  style?: React.CSSProperties;
}

/** Shared loading indicator. Styles live in styles/components/feedback.css. */
const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  label,
  layout = 'block',
  className = '',
  style,
}) => {
  const ring = `spinner spinner--${size}`;

  if (layout === 'bare') {
    return label ? (
      <span className={`${ring} ${className}`} style={style} role="status" aria-label={label} />
    ) : (
      <span className={`${ring} ${className}`} style={style} aria-hidden="true" />
    );
  }

  const layoutClass =
    layout === 'inline'
      ? ' spinner-block--inline'
      : layout === 'fullscreen'
      ? ' spinner-block--fullscreen'
      : '';

  return (
    <div className={`spinner-block${layoutClass} ${className}`} style={style} role="status">
      <span className={ring} aria-hidden="true" />
      {label ? <span>{label}</span> : <span className="sr-only">Loading</span>}
    </div>
  );
};

export default Spinner;
